(() => {
  if (window.dibaoFaqAccordionReady) return;
  window.dibaoFaqAccordionReady = true;

  const normalize = (value) => value.replace(/\s+/g, ' ').trim();
  const questionPattern = /[?？]\s*$/;
  const questionPrefix = /^Q\s*\d*\s*[:：.、]\s*/i;
  const answerPrefix = /^A\s*\d*\s*[:：.、]\s*/i;
  const isQuestion = (node) => {
    if (node.nodeType !== Node.ELEMENT_NODE || !/^(P|H[2-6])$/.test(node.tagName)) return false;
    const text = normalize(node.textContent);
    if (!text || text.length > 240 || answerPrefix.test(text)) return false;
    if (node.querySelector('a, button, input, select, textarea, details, summary, iframe')) return false;
    const bold = Array.from(node.querySelectorAll('strong, b')).map((item) => normalize(item.textContent)).join(' ');
    const hasQuestionMarker = questionPattern.test(text) || questionPrefix.test(text);
    return hasQuestionMarker && (/^H[2-6]$/.test(node.tagName) || bold === text || questionPrefix.test(text));
  };
  const meaningful = (node) => normalize(node.textContent || '') !== ''
    || (node.nodeType === Node.ELEMENT_NODE && (node.matches('img, video, audio, table, iframe')
      || Boolean(node.querySelector('img, video, audio, table, iframe'))));
  const linksAndMedia = (root) => Array.from(root.querySelectorAll('a, img, video, audio, iframe'))
    .map((node) => node.outerHTML);

  const enhance = (container) => {
    if (container.contains(document.activeElement)) return;
    if (container.classList.contains('is-dibao-faq-enhanced')) return;
    const nodes = Array.from(container.childNodes);
    const groups = [];
    let current;
    for (const node of nodes) {
      if (isQuestion(node)) {
        if (current && !current.answer.some(meaningful)) return;
        current = { question: node, answer: [] };
        groups.push(current);
      } else if (current) {
        current.answer.push(node);
      } else if (meaningful(node)) {
        return;
      }
    }
    if (!groups.length || !current.answer.some(meaningful)) return;
    if (container.querySelector('details, summary, script, style, form')) return;

    const fragment = document.createDocumentFragment();
    const firstQuestion = nodes.indexOf(groups[0].question);
    nodes.slice(0, firstQuestion).forEach((node) => fragment.append(node.cloneNode(true)));
    groups.forEach((group, index) => {
      const details = document.createElement('details');
      const summary = document.createElement('summary');
      const question = document.createElement('span');
      const answer = document.createElement('div');
      details.className = 'dibao-faq-accordion__item';
      summary.className = 'dibao-faq-accordion__summary';
      answer.className = 'dibao-faq-accordion__answer';
      Array.from(group.question.attributes).forEach((attribute) => question.setAttribute(attribute.name, attribute.value));
      question.classList.add('dibao-faq-accordion__question');
      Array.from(group.question.childNodes).forEach((node) => question.append(node.cloneNode(true)));
      group.answer.forEach((node) => answer.append(node.cloneNode(true)));
      summary.append(question);
      details.append(summary, answer);
      if (index === 0) details.open = true;
      fragment.append(details);
    });
    if (normalize(fragment.textContent) !== normalize(container.textContent)) return;
    if (JSON.stringify(linksAndMedia(fragment)) !== JSON.stringify(linksAndMedia(container))) return;
    container.replaceChildren(fragment);
    container.classList.add('is-dibao-faq-enhanced', 'dibao-faq-accordion');
  };

  const scan = (root) => {
    if (root.matches?.('.rich-text--dibao-faq .metafield-rich_text_field')) enhance(root);
    root.querySelectorAll('.rich-text--dibao-faq .metafield-rich_text_field').forEach(enhance);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  } else {
    scan(document);
  }
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
